import { createAsyncThunk } from '@reduxjs/toolkit';
import { KbContentOption } from './models/kb-content-option.model';

export const GetActiveKbContentOptions = createAsyncThunk(
    'marketplace/pricing/getActiveKbContentOptions',
    async (_, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const response = await axios.get('/api/KnowledgeBase/active-options');
        return response.data as KbContentOption[];
    }
);
